<template>
  <div id="home">
    <my-header></my-header>
    <div class="image-store height-auto">
      <img src="/static/images/cover.jpg" />
    </div>
    <div class="pd40">

      <div class="row">
        <div class="col-md-8">
          <img v-if="type == 'farmer'" src="/static/images/farm.jpg" class="border-radius-8" style="max-height:400px" />
          <img v-if="type == 'packager'" src="/static/images/packing.jpg" class="border-radius-8" style="max-height:400px" />
          <img v-if="type == 'retailer'" src="/static/images/retail.jpg" class="border-radius-8" style="max-height:400px" />
        </div>
        <div class="col-md-4">
          <div v-if="type == 'farmer'">
            <h3>Nhà vườn</h3>
            <ul>
              <li>- được hỗ trợ kỹ thuật</li>
              <li>- được hướng dẫn thực hành theo tiêu chuẩn GAP (VietGAP, GlobalGAP)</li>
              <li>- được kết nối với các vựa thu mua ở địa phương</li>
              <li>- được kết nối với hàng ngàn khách hàng bán sỉ và bán lẻ trên toàn quốc</li>
              <li>- được thường xuyên cập nhật thông tin thị trường</li>
            </ul>
          </div>
          <div v-if="type == 'packager'">
            <h3>Vựa thu mua</h3>
            <ul>
              <li>- được hướng dẫn thực hành theo tiêu chuẩn GMP cho cơ sở thu mua</li>
              <li>- được kết nối với cách khách hàng trong nước & xuất khẩu (trường hợp sản phẩm có nhu cầu từ nước ngoài và đạt tiêu chuẩn xuất khẩu)</li>
              <li>- được kết nối với hàng ngàn khách hàng bán sỉ và bán lẻ trên toàn quốc</li>
              <li>- có đội ngũ hỗ trợ nhận đơn hàng, tư vấn cho khách hàng</li>
              <li>- được thường xuyên cập nhật thông tin thị trường</li>

            </ul>
          </div>
          <div v-if="type == 'retailer'">
            <h3>Nhà bán sỉ & lẻ</h3>
            <ul>
              <li>- được kết nối với nhiều cơ sở thu mua và nhà vườn trồng cây Có Múi ở huyện Bắc Tân Uyên</li>
              <li>- được tư vấn về các tiêu chuẩn của sản phẩm</li>
              <li>- sản phẩm có truy xuất nguồn gốc</li>
              <li>- được giao hàng tận nơi hoặc hỗ trợ tìm xe vận chuyển</li>
            </ul>
          </div>
          <a class="btn btn-success w-100" v-on:click="redirectLogin(type)" >Đăng ký</a>
        </div>
      </div>

      <!-- <a class="text-center mt40" v-on:click="needLogin" ><h4><i class="fas fa-search"></i> Tìm kiếm vựa thu mua</h4></a> -->
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'

import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'

export default {
  name: 'Home',
  components: {
    MyHeader,
    Loading
  },
  data () {
    return {
      type: ''
    }
  },

  methods: {
    needLogin (type) {
      this.$alertify.error(this.$t('Bạn cần đăng nhập để sử dụng chức năng này'))
      window.REQUIRE_LOGIN_ROUTE_NAME = 'Home'

      this.$router.push({ name: 'Login' })
    },
    redirectLogin (type) {
      console.log('type', type)
      window.REQUIRE_LOGIN_ROUTE_NAME = 'CallbackLogin'
      window.ROUTE_PARAMS = {
        type: type
      }
      console.log('window.ROUTE_PARAMS', window.ROUTE_PARAMS)

      this.$router.push({ name: 'Login' })
    }
  },

  mounted () {
    this.type = this.$route.params.type
    // let user = Utils.getUser(this)
    // if (user) {
    //   this.$router.push({ name: 'SearchPackagerStore' })
    // }
  },
  beforeDestroy () {}
}
</script>



// WEBPACK FOOTER //
// src/components/Page/FurtherInfo.vue